import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { ideationTopicList_template } from "../components/templates/ideationTopicList_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class ideation_topic extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: ideationTopicList_template;


    protected getModuleName(): string {

      return "ideation_topic";
    }

    buildContent(): Array<Element> {

        this.elementsList = new ideationTopicList_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Ideation Topics");

        return [this.elementsList.build()];
    }

    public fillPage() {

      this.elementsList.buildDatePickerCalendar();
      this.filterList();
    }

    protected paginationOnPageClick(){

      this.filterList();
    }

    protected topicsListReorder(){

      this.filterList();
    }

    protected filterSimpleOnChange(){

      this.viewModel.list.pagination.pageNumber(1);
      this.filterList();
    }

   protected onAutocompleteInputClick(idElement) {

  }

  protected onAutocompleteInputClear(idElement) {
    let filter = document.getElementById(idElement + "_input");
    if(filter){
      filter.classList.remove("is-disable");
    }
    let selectedSource = this.elementsList.getSelectedSource();
    if(selectedSource != null){
      this.filterList();
    }
    this.elementsList.setSelectedSource(null);
    this.elementsList.setSelectedSeed(null);
    this.elementsList.setIsShowGenerateButton(false);
  }

  protected onAutocompleteAddNewSelected(idElement) {

  }

  protected onAutocompleteAddNewInputChange(idElement) {
     this.elementsList.setIsShowGenerateButton(true);
  }

  protected onAutocompleteAddNewInputClick(idElement) {

  }
  protected onAutocompleteOptionChange(idElement) {
    let button = document.getElementById(
      "autocomplete-input-close-" + idElement
    );
    if (button) {
      button.classList.add("is-showing");
    }
    let filter = document.getElementById(idElement + "_input");
    if(filter){
      filter.classList.add("is-disable");
    }

    if(idElement == "seedFilter"){
        this.elementsList.setSeedFilterText(this.elementsList.getSeedFilterSelectionName());
        //this.elementsList.setSelectedSeed
    }else{
      this.elementsList.setSourceFilterText(this.elementsList.getSourceFilterSelectionName());
      this.elementsList.setSelectedSource(this.elementsList.getSourceFilterSelection());
      this.elementsList.setIsShowGenerateButton(true);
    }


    this.filterList();
  }

  protected getSuggestions(keyword, idSourceElement) {

    if(idSourceElement == "seedFilter"){
      this.getSeedsSuggestion(keyword, 5);
    }else{
      this.getSourcesSuggestion(keyword, 5);
    }

  }

  protected getSeedsSuggestion(keyword, limit) {
      if (this.XHRHdl) {
        this.XHRHdl.cancelAndReset();
      }

      let subViewModel = { filter: { keyword: keyword, limit: limit } };
      let usrReq_url: string =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/ideation/seeds/search/";
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push(["data", ko.toJSON(subViewModel)]);
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

      this.XHRHdl.onReadyStateFunction = this.onGetSeedsSuggestionReturn;
      this.XHRHdl.execute();
    }
    protected onGetSeedsSuggestionReturn(req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);

           obj.elementsList.setSeedFilterOptions(
              responseParsed.seeds
           );
        });
      };
    }

    protected getSourcesSuggestion(keyword, limit) {
      if (this.XHRHdl) {
        this.XHRHdl.cancelAndReset();
      }

      let subViewModel = { filter: { keyword: keyword, limit: limit } };
      let usrReq_url: string =
        "/api/brand/" +
        this.getVnAppZone().app.params.idBrand +
        "/ideation/sources/search/";
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push(["data", ko.toJSON(subViewModel)]);
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

      this.XHRHdl.onReadyStateFunction = this.onGetSourcesSuggestionReturn;
      this.XHRHdl.execute();
    }
    protected onGetSourcesSuggestionReturn(req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);

           obj.elementsList.setSourceFilterOptions(
              responseParsed.sources
           );
        });
      };
    }

    protected editSources(){

       page('/brand/' + this.getVnAppZone().app.params.idBrand + '/ideation/sources/');
    }

    protected filterDateOnChange(idElement){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

      if( this.XHRHdl ){
          this.XHRHdl.cancelAndReset();
      }
    }

    protected filterList() {

      if (this.XHRHdl) {
          this.XHRHdl.cancelAndReset();
      }

      // LOADING : starts
      this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

      let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand +'/ideation/topics/get';
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
      this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
      this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

      return function(){
          obj.manageResponse(req, obj, function(){

              let responseParsed = JSON.parse(req.request.response);
              obj.updateList(responseParsed);
          });
          obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
      }
    }

    protected updateList(responseParsed: any){

      let topicsToSet = responseParsed.data;

      let previousCategory = null;
      let categoryClassIndex = 0;

      topicsToSet.forEach(topic => {
        let currentCategory = topic.category;
        if (currentCategory.includes("(https://")) {
          currentCategory = currentCategory.replace(/\s*\(https:\/\/.*?\)/, "");
        }

        // Check if the category has changed from the previous topic
        if (previousCategory === null || currentCategory !== previousCategory) {
            // If it's the first topic or the category is different, cycle the index
            categoryClassIndex = (categoryClassIndex % 3) + 1; // Cycles 1, 2, 3
        }

        // Add the categoryClass field to the current topic object
        topic.categoryClass = 'cat-' + categoryClassIndex;

        // Update the previousCategory for the next iteration
        previousCategory = currentCategory;

        topic.originalCategory = topic.category;
        topic.originalKeyPoints = [...topic.keyPoints];
        topic.originalTrendingReason = topic.trendingReason;

        topic.keyPoints.forEach((keyPoint, index) => { // 'index' is available here
            // Modify the array element directly using its index
            topic.keyPoints[index] = this.convertUrlsToLinks(keyPoint);
        });

         topic.category = this.convertUrlsToLinks(topic.category);

         topic.trendingReason = this.convertUrlsToLinks(topic.trendingReason);

         if(topic.ctrScore != null){

            topic.ctrClass = "ctr-green";
            if(topic.ctrScore < 5){
                topic.ctrClass = "ctr-yellow";
            }else if(topic.ctrScore < 12){
                topic.ctrClass = "ctr-blue";
            }
         }

         if(topic.ctrScore != null && topic.similarArticles != null && topic.similarArticles.length > 0){

            let tooltipHtml = topic.ctrScore + '% average CTR from similar articles:<br/><br/>';
            topic.similarArticles.forEach((article, index) => { // 'index' is available here
              let ctr = article.ctr ? article.ctr : 0;

              tooltipHtml += `<a href="${article.url}" target="_blank">${article.title} (${ctr}%)</a><br/>`;
            });

            topic.ctrTooltip = tooltipHtml;
         }
      });

      this.elementsList.setTopics(topicsToSet);

      let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
      this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

      let sourcesToSet = responseParsed.extraData.sources;
      this.elementsList.setSources(sourcesToSet);

      let idSourceSelected = responseParsed.extraData.idSource;
      this.elementsList.setIdSelectedSource(idSourceSelected);

      let selectedSource = sourcesToSet.find(source => source.id === idSourceSelected);
      //this.elementsList.setSelectedSource(selectedSource);

      this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

  private convertUrlsToLinks(text) {

      text = text
          .replace(/[\r\n]+/g, '')
          .replace(/\[/g, '<span><strong><sup style="font-size: 7.7px">[')
          .replace(/\]/g, ']</sup></strong>&nbsp;');

      // Improved regex to match URLs with internal parentheses
      const urlRegex = /(?:\()?(https?:\/\/[^\s()<>]+(?:\([^\s()<>]*\)[^\s()<>]*)*)(?:\))?/g;

      return text.replace(urlRegex, (match, url) => {
          let href = url;

          // Only strip parentheses if they are actually wrapping
          const isWrapped = match.startsWith('(') && match.endsWith(')');
          if (isWrapped && !href.endsWith(')')) {
              // avoid removing if last `)` belongs to the URL
              href = match.slice(1, -1);
          }

          // --- Logic to extract the domain for linkText ---
          let linkText = href;

          // 1. Remove 'http://' or 'https://'
          linkText = linkText.replace(/^(https?:\/\/)/, '');

          // 2. Remove 'www.' if present
          linkText = linkText.replace(/^www\./, '');

          // 3. Remove any trailing slash
          linkText = linkText.endsWith('/') ? linkText.slice(0, -1) : linkText;

          // 4. Remove path, query parameters, or hash
          const firstSlashIndex = linkText.indexOf('/');
          if (firstSlashIndex !== -1) {
              linkText = linkText.substring(0, firstSlashIndex);
          }

          return `<a class="link-sourse" target="_blank" href="${href}">${linkText}</a></span>`;
      });
  }


  protected saveSegment(segmentToSave) {
    let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/segments/save';
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(segmentToSave)]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction = this.onSaveSegmentRequestReturn;
    this.XHRHdl.execute();
  }

   protected deleteTopic(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/ideation/topics/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    console.log(responseParsed)

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "<strong>" + responseParsed.data.name + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule();
                    obj.filterList();
                })

                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));

            }
        });
        XHRHdl.execute();

    }

  protected onSaveSegmentRequestReturn(req, obj){

    return function(){
        obj.manageResponse(req, obj, function(){
            obj.filterList();
        });
    }
  }

  protected generateTopics(idSource, newSourceName) {

    if (this.XHRHdl) {
        this.XHRHdl.cancelAndReset();
    }

    // LOADING : starts
    this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

    let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand +'/ideation/topics/generate';
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON({idSource: idSource, newSourceName: newSourceName})]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGenerateTopicsRequestReturn;
    this.XHRHdl.execute();
  }

    protected onGenerateTopicsRequestReturn(req, obj){

      return function(){
          obj.manageResponse(req, obj, function(){

              let responseParsed = JSON.parse(req.request.response);
              document.getElementById("generate-btn").removeAttribute("disabled");
              document.getElementById("generate-btn").innerText = "Generate";

              if(responseParsed.source){
                obj.elementsList.toggleAddNew();
                obj.elementsList.setSourceFilterOption(responseParsed.source);
                obj.elementsList.setSelectedSource(responseParsed.source);
              }else{
                obj.filterList();
              }


          });
          obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
      }
    }

    public getIdBrand() {
      return Number(this.getVnAppZone().app.params.idBrand);
    }
}



// WEBPACK FOOTER //
// ./js/modules/ideation_topic.ts